import { Modal } from '@/components/ui/Modal';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  countdown: number;
  onStayLoggedIn: () => void;
}

export function SessionTimeoutModal({
  isOpen,
  countdown,
  onStayLoggedIn,
}: SessionTimeoutModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onStayLoggedIn}
      title="Session Expiring"
      actionLabel="Stay Logged In"
      onAction={onStayLoggedIn}
      cancelLabel=""
      size="sm"
    >
      <div className="text-center">
        <p className="text-body-small mb-4">
          Your session is about to expire due to inactivity.
        </p>
        <p className="text-body-small-strong">
          You will be logged out in{' '}
          <span className="text-destructive">{countdown}</span>{' '}
          {countdown === 1 ? 'second' : 'seconds'}.
        </p>
      </div>
    </Modal>
  );
}
